<template>
  <div>
    <my-head></my-head>
    <img src="../../assets/Rectangle353.png" style="width: 100%" />
    <div class="financialservice minH">
      <div class="service_title">知识产权质押融资</div>

      <div class="service_content">
        知识产权质押是指知识产权权利人以合法拥有的专利权、注册商标专用权、著作权等知识产权中的财产权为质押标的物出质，经评估作价后向银行等融资机构获取资金，并按期偿还资金本息的一种融资行为。目前的国内知识产权质押融资，是为了解决中小企业融资面临的贷款门槛高、融资难、融资贵的困局而提出的一种具有创新意义的信贷品种，主要是以合法拥有的专利、商标、版权等知识产权作为质押物，经过评估机构评估价值后，由银行按照一定的质押率提供贷款的融资模式。<br /><br />
        国内知识产权质押融资工作已在全国范围内广泛推行，融资规模不断扩大，融资金额逐年攀升，一定程度上破解了中小微企业“融资难、融资贵”的难题，对实现专利价值、服务中小微企业、助力创新发展起到了重要作用。
      </div>

      <div class="service_title_1 flex-between">
        <span>产品介绍</span>
        <!-- <router-link to="/">查看更多 ></router-link> -->
        <a href="javascript:;">查看更多 ></a>
      </div>

      <div class="list_top flex-left">
        <img src="../../assets/icon/service_1.png" />

        <div class="top_content">
          <div class="top_title">中国农业银行上海市分行</div>

          <div class="top_fl">费率</div>

          <div class="top_yh">根据同期贷款利率水平给予较优惠利率</div>

          <div class="top_nr">
            资产担保债券：发行人以资产为担保进行动态管理并足额覆盖未偿付金额的信用债券。科创类企业拥有的具有独创性和市场认可的知识产权资产可以作为资产进行抵质押增信，增强信用主体的融资能力；债券增信可降低发行人融资成本，拓宽发行人融资渠道。<br />
            科易贷：向科创型企业发放的，用于企业生产经营周转的最长不超过3年的中短期信贷业务。该产品准入级别低于一般贷款，额度理论值不足的重点客户可以追加不超过3亿元授信额度理论值，可采用信用、知识产权质押方式。<br />
            专精特新小巨人贷：为“专精特新”企业办理的用于其日常生产经营周转和固定资产投资的本外币信贷业务。该产品额度大，融资金额不设上限，流动资金贷款最长为3年，可采用信用、知识产权质押方式。
          </div>
        </div>
      </div>

      <!-- <div class="service_list flex-between flex-wrap">
        <div
          class="service_col flex-left"
          v-for="(item, index) in serlist"
          :key="index"
        >
          <img :src="item.img" />
          <div>
            <div class="col_title">{{ item.title }}</div>
            <div class="col_fl">费率</div>
            <div class="col_nr">{{ item.fl }}</div>
          </div>
        </div>
      </div> -->

      <div class="service_bottom flex-center">
        <div class="flex-between">
          <div>
            平台流程及企业需求申报文件
            <!-- <span>国际平台-预评估资料清单.docx</span> -->
            <a
              class="service_qd"
              :href="downloadUrl"
              download="国际平台—预评估资料清单.docx"
              >国际平台-预评估资料清单.docx</a
            >
          </div>
          <!-- <a class="service_sq flex-center" href="javascript:;">立即申请</a> -->
          <router-link class="service_sq flex-center" to="/valuationform">
            立即申请
          </router-link>
        </div>
      </div>
    </div>
    <my-footer></my-footer>
  </div>
</template>

<script>
import MyHead from "../../components/MyHead.vue";
import MyFooter from "../../components/MyFooter.vue";
export default {
  components: { MyHead, MyFooter },
  data() {
    return {
      serlist: [
        {
          img: require("../../assets/icon/service_2.png"),
          title: "上海银行",
          fl: "提供普惠金融优惠贷款利率",
        },
        {
          img: require("../../assets/icon/service_3.png"),
          title: "兴业银行上海分行",
          fl: "最低可达基准下浮10%，且没有其他任何费用。",
        },
        {
          img: require("../../assets/icon/service_4.png"),
          title: "中国工商银行上海市分行",
          fl: "根据同期短期贷款利率，设定合理贷款利率。",
        },
        {
          img: require("../../assets/icon/service_5.png"),
          title: "江苏银行上海分行",
          fl: "根据同期短期或中期贷款利率，给予优惠贷款利率。",
        },
      ],
    };
  },
  computed: {
    downloadUrl() {
      let url = window.location.href;
      return `${url.split("#")[0]}static/国际平台—预评估资料清单.docx`;
    },
  },
};
</script>

<style lang="scss">
.financialservice {
  width: 80%;
  margin: 48px auto 60px;
  .service_bottom {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100vw;
    height: 70px;
    background: #f7f8fa;
    box-shadow: 0px -1px 0px 1px #f0f0f0;
    font-size: 16px;
    font-weight: 500;
    color: #1d2129;
    & > div {
      width: 80%;
      .service_qd {
        font-size: 14px;
        margin-left: 16px;
        font-weight: 400;
        color: #165dff;
        cursor: pointer;
      }
      .service_sq {
        background: #165dff;
        border-radius: 4px;
        width: 163px;
        height: 36px;
        font-size: 14px;
        font-weight: 500;
        color: #ffffff;
        border: none;
      }
    }
  }
  .service_list {
    padding-bottom: 80px;
    .service_col {
      width: 48%;
      padding: 32px;
      background: linear-gradient(180deg, #f7f8fa 0%, #ffffff 49%);
      border-radius: 12px 12px 12px 12px;
      border: 1px solid #e5e6eb;
      margin-bottom: 24px;
      .col_nr {
        font-size: 16px;
        padding: 4px 8px;
        font-weight: 500;
        color: #c37d3a;
        line-height: 24px;
        background: linear-gradient(
          90deg,
          #fff3dd 0%,
          #fff3dd 26%,
          #ffffff 100%
        );
        border-radius: 4px;
        opacity: 1;
        border: 1px solid;
      }
      .col_fl {
        font-size: 14px;
        font-weight: 400;
        color: #86909c;
        line-height: 22px;
        margin-bottom: 2px;
      }
      .col_title {
        font-size: 20px;
        font-weight: 500;
        color: #1d2129;
        line-height: 28px;
        margin-bottom: 12px;
      }
      img {
        width: 50px;
        margin-right: 30px;
      }
    }
  }
  .list_top {
    width: 100%;
    background: linear-gradient(180deg, #f7f8fa 0%, #ffffff 49%);
    border-radius: 12px;
    border: 1px solid #e5e6eb;
    padding: 34px;
    margin-bottom: 24px;
    .top_content {
      .top_nr {
        font-size: 13px;
        font-weight: 400;
        color: #4e5969;
        line-height: 22px;
      }

      .top_yh {
        font-size: 16px;
        font-weight: 500;
        color: #c37d3a;
        padding: 4px 8px;
        background: linear-gradient(
          90deg,
          #fff3dd 0%,
          #fff3dd 26%,
          #ffffff 100%
        );
        border-radius: 4px;
        border: 1px solid;
        margin-bottom: 16px;
      }

      .top_fl {
        font-size: 14px;
        font-weight: 400;
        color: #86909c;
        line-height: 22px;
        margin-bottom: 2px;
      }

      .top_title {
        font-size: 20px;
        font-weight: 500;
        color: #1d2129;
        line-height: 28px;
        margin-bottom: 12px;
      }
    }
    img {
      width: 50px;
      margin-right: 20px;
      position: relative;
    }
  }
  .service_title_1 {
    font-size: 20px;
    font-weight: 500;
    color: #1d2129;
    line-height: 28px;
    margin-bottom: 24px;
    a {
      font-size: 14px;
      font-weight: 400;
      color: #165dff;
      line-height: 22px;
    }
  }
  .service_content {
    font-size: 14px;
    font-weight: 400;
    color: #4e5969;
    line-height: 28px;
    margin-bottom: 32px;
  }
  .service_title {
    font-size: 24px;
    font-weight: bold;
    color: #1d2129;
    line-height: 32px;
    margin-bottom: 24px;
  }
}
</style>
